// extracted by mini-css-extract-plugin
module.exports = {"main":"flavours-odl-main-ca00c075","other":"flavours-odl-other-97760c02"};